<template>
  <div class="menu-nav-warpper">
    <div class="inner_center">
      <div class="category-list-box category-box" v-if="params.categoryType == 0">
        <div class="category-name ">分类：</div>
        <div
          class="category-list"
          :class="[
            { 'NO': other_list.length == 0 },
            categoryMoreStatus ? 'OPEN':'CLOSE',
          ]"
          ref="self_list"
        >

          <div class="category-list-inner"
               :class="{ 'mr': category_listMore || other_list.length == 0 }"
               ref="CategoryListInner">
            <a
              :href="vo.link"
              ref="self_listItem"
              :class="{ 'on': params.module == vo.id }"
              v-for="(vo,idx) in self_list"
              :key="idx + 'menuNavList' ">
              {{ vo.name }}
            </a>
            <div class="more common_more" v-if="category_listMore"
                 @click="toggleCategory"
            >
              {{ categoryMoreStatus ? '收起' : '更多' }}<i class="iconfont icon-a-arrowright"
                                                       :class="{ 'sq':  categoryMoreStatus }"/>
            </div>
          </div>
        </div>

        <div class="other-category-list"
             :class="[
            { 'NO': other_list.length == 0 },
            otherCategoryMoreStatus ? 'OPEN':'CLOSE',
          ]"
             v-show="other_list.length"
        >
          <div class="other-category-list-inner"
               ref="OtherCategoryListInner">
            <a
              :href="vo.link"
              :title="vo.name "
              v-for="(vo,idx) in other_list" :key="idx + 'sceneList' "
            >{{ vo.name }}
            </a>

            <div class="more common_more" v-if="othercategory_listMore"
                 @click="toggleOtherCategory"
            >
              {{ otherCategoryMoreStatus ? '收起' : '更多' }}<i class="iconfont icon-a-arrowright"
                                                            :class="{ 'sq':  otherCategoryMoreStatus }"/>
            </div>
          </div>
        </div>
      </div>

      <div class="category-list-box category-box category-box-style" v-else>
        <div class="category-name ">设计风格：</div>
        <div
          class="category-list"
          ref="self_list"
        >
          <a
            :href="vo.link"
            class="category"
            ref="self_listItem"
            :class="{ 'on': params.design == vo.id }"
            v-for="(vo,idx) in styleClassify"
            :key="idx + 'menuNavList' ">
            {{ vo.name }}
          </a>
        </div>
      </div>

      <div class="category-list-box scene-list-box" v-if="category_list.length > 1 && params.categoryType == 0">
        <div class="category-name">行业：</div>
        <div class="category-list">
          <a
            :href="vo.link"
            class="category"
            :class="{ 'on': params.category == vo.id }"
            v-for="(vo,idx) in category_list" :key="idx + 'sceneList' "> {{ vo.name }}</a>
        </div>
      </div>

      <div class="category-list-box scene-list-box" v-if="scene_list.length > 1 && params.categoryType == 0 ">
        <div class="category-name">场景：</div>
        <div class="category-list">
          <a
            :href="vo.link"
            class="category"
            :class="{ 'on': params.scene == vo.id }"
            v-for="(vo,idx) in scene_list" :key="idx + 'sceneList' "> {{ vo.name }}</a>
        </div>
      </div>
    </div>

    <div class="menu-box-wrap">
      <div class="menu-box inner_center">
        <div class="layout-left">
          <div class="category-list-box category-box type-box">
            <div class="category-name">类型：
            </div>
            <div class="type-list">
              <a
                :href="vo.link"
                @click.prevent="toggleType(vo,idx)"
                class="category"
                v-for="(vo,idx) in typeList" :key="idx + 'sceneList' ">
                <i
                  class="iconfont"
                  :class="[
                    // vo.isChecked ? 'icon-checkbox': 'icon-checkbox2',
                    (params.layer.length && params.layer.indexOf(vo.id) > -1) ? 'icon-checkbox': 'icon-checkbox2',
                  ]"

                />
                <div class="title">
                  {{ vo.title }}
                  <no-ssr>
                    <div class="dropbox" v-if="vo.label && vo.label.length">
                      <div class="dropbox-item">
                        {{ vo.label }}
                      </div>
                    </div>
                  </no-ssr>
                </div>
              </a>
            </div>
          </div>
          <i class="icon_line"/>

          <div class="menu-list-box">
            <div class="category-name">排序：
            </div>
            <ul
              class="menu-list"
            >
              <li
                v-for="(vo,idx) in menuList"
                :class="[ 'menu-item _pointer', { 'on': params.desc === vo.sort } ]"
                :key="vo.id + 'menuList'"
              >
                <a :href="vo.link">{{ vo.title }} </a>
                <i class="icon_recent-new" v-if="idx === 2">{{ materialNum }}</i>
              </li>
            </ul>
          </div>

        </div>


        <div
          class="category-list-box scene-list-box"
          @mouseover="isShow = true"
          @mouseleave="isShow = false"
        >
          <div class="category-name">
            {{ params.layout | LayoutName }}
            <template v-if="params.layout == 0">
              <i class="icon_down"/>
            </template>

            <template v-else>
              <i class="iconfont3 icon-cz-close-circle-fill"
                 @click="resetLayer"
              />
            </template>
          </div>
          <div
            v-if="isShow"
            class="scene-list">
            <a
              :href="vo.link"
              class="scene"
              @click.prevent="checkScene(vo)"
              :class="{ 'ON': params.layout == vo.id }"
              v-for="(vo,idx) in usageTypeList" :key="idx + 'usageTypeList' "> {{ vo.title }}</a>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {menuNavList, sceneList} from "@/components/home/common/module";
// import {usageTypeList} from "@/components/list/module";
import {MATERIAL_LIST_PATH} from "@/constant/PATH";
import {fnRouter} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {parseListUrl, timeList, typeList, usageTypeList} from "@/components/list/module";

export default {
  name: "ListMenuNav",
  data() {
    return {
      menuNavList,
      sceneList,
      // usageTypeList,
      newSelfList: [],
      MATERIAL_LIST_PATH,
      isShow: false,
      category_listMore: false,
      categoryMoreStatus: false,

      othercategory_listMore: false,
      otherCategoryMoreStatus: false,

    }
  },

  props: {
    params: {
      type: String | Number,
      default: {},
    },
    materialNum: {
      type: String | Number,
      default: '',
    },

    self_list: {
      type: Array,
      default: () => [],
    },
    other_list: {
      type: Array,
      default: () => [],
    },
    category_list: {
      type: Array,
      default: () => [],
    },
    scene_list: {
      type: Array,
      default: () => [],
    },
    usageTypeList: {
      type: Array,
      default: () => [],
    },
    menuList: {
      type: Array,
      default: () => [],
    },
    typeList: {
      type: Array,
      default: () => [],
    },
    styleClassify: {
      type: Array,
      default: () => [],
    },
  },


  /*
  *   1. 类型 只有 self_list 并且 other_list.length == 0
  *   2.  self_list 并且 other_list.length > 0
  *  */
  watch: {

    other_list: {
      handler(n, o) {

        if (n.length) {
          console.log('other_list')

          this.$nextTick(() => {

            if (this.$refs.OtherCategoryListInner) {
              console.log('-------------------------')
              console.log(this.$refs.OtherCategoryListInner.offsetHeight)

              let CategoryListInnerHeight = this.$refs.OtherCategoryListInner.offsetHeight;
              this.othercategory_listMore = CategoryListInnerHeight > 50
            }

          })


        } else {
          console.log('other_list 为空');

          /* 获取内部div的高度是否比父级高，高则显示更多，否则反之 */

          this.$nextTick(() => {
            if (this.$refs.CategoryListInner){
              console.log('-------------------------')
              console.log(this.$refs.CategoryListInner.offsetHeight)
              let CategoryListInnerHeight = this.$refs.CategoryListInner.offsetHeight;
              this.category_listMore = CategoryListInnerHeight > 50
            }

          })


        }

      },
      immediate: true,
      deep: true
    }
  },

  mounted() {
    this.initViewWidth();
    window.onresize = () => {
      this.initViewWidth();
      this.$emit('resize')
    }
  },
  methods: {
    initViewWidth() {
      this.viewWidth = document.body.clientWidth > 1440 ? 1440 : 1200;
      // this.calendarListLength = this.viewWidth >= 1440 ? 3 : 2
    },


    toggleCategory() {
      this.categoryMoreStatus = !this.categoryMoreStatus;
    },

    toggleOtherCategory() {
      this.otherCategoryMoreStatus = !this.otherCategoryMoreStatus;
    },

    disposeLayer(str, id) {
      let strArr;
      if (str == 0) {
        strArr = ['0']
      } else {
        strArr = str.split('$');
      }

      let index = strArr.indexOf(id)
      if (index > -1) {
        strArr = strArr.filter(vo => vo != id)
      } else {
        strArr.push(id)
      }

      if (strArr.length) {
        strArr = strArr.filter(vo => vo > 0)
        return strArr.join('$')
      } else {
        return 0
      }

      /*  */
    },
    toggleType(vo, idx) {
      this.layoutId = vo.id;
      let urlParams = parseListUrl(this.$route.path, this.$route.params.id)
      let {
        pinyin,
        home_keyword_id,
        layout,
        time_filter,
        module,
        category,
        scene,
        page,
        desc,
        layer,
        categoryType,
        design
      } = urlParams;
      let layerStr = this.disposeLayer(layer, vo.id)

      let path;
      if (categoryType == 0) {
        path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-${layout}-${time_filter}-${module}-${category}-${scene}-${desc}-1-${layerStr}-0-0.html`;
      } else {
        path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-${layout}-${time_filter}-${module}-0-${scene}-${desc}-1-${layerStr}-${design}-1.html`;
      }
      fnRouter.navigationTo(path, '_self');

    },
    resetLayer() {
      let urlParams = parseListUrl(this.$route.path, this.$route.params.id)
      let {pinyin, home_keyword_id, layout, time_filter, module, category, scene, page, desc, layer} = urlParams;
      if (urlParams.categoryType == 0) {
        let path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-0-${time_filter}-${module}-${category}-${scene}-${desc}-1-0.html`;
        fnRouter.navigationTo(path, '_self');
      } else {
        let path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-0-${time_filter}-${module}-${category}-${scene}-${desc}-1-0-${urlParams.design}-1.html`;
        fnRouter.navigationTo(path, '_self');
      }


    },

    checkScene(vo) {
      if (vo.id != this.params.layout) {
        fnRouter.navigationTo(vo.link, '_self');
      } else {
        let urlParams = parseListUrl(this.$route.path, this.$route.params.id)
        let {pinyin, home_keyword_id, layout, time_filter, module, category, scene, page, desc, layer} = urlParams;
        let path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-0-${time_filter}-${module}-${category}-${scene}-${desc}-1-${layer}.html`;
        fnRouter.navigationTo(path, '_self');
      }

    }
  },
  filters: {
    LayoutName(val) {
      let findOne = usageTypeList.findIndex(vo => vo.id == val);
      console.log(findOne)
      if (findOne > -1) {
        return usageTypeList[findOne].title;
      } else {
        return '格式';
      }
    },
    timeFilterName(val) {
      let findOne = timeList.find(vo => vo.id == val);
      return findOne.title;
    }
  }
}
</script>

<style lang="scss" scoped>

.common_more {
  @include Position(1, 2, 0, 0);
  display: inline-block;
  font-size: 14px;
  color: #424866;
  line-height: 26px;
  height: 26px;
  padding: 0 8px;
  cursor: pointer;

  .icon-a-arrowright {
    margin-left: 4px;

  }
}

@keyframes fadeinT {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


.menu-nav-warpper {
  background-color: #fff;

  .category-list-box {
    display: flex;
    //margin-bottom: 16px;

    &.category-box-style {
      .category-list {
        flex-shrink: 1 !important;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }


    .category-name {
      margin-right: 12px;
      font-size: 14px;
      //color: #0A2540;
      color: rgba(0, 16, 19, 0.45);
      line-height: 26px;
      flex-shrink: 0;
    }


    .category-list {
      font-size: 0;
      //height: 40px;
      transition: all 0.5s ease;

      &.CLOSE {
        height: 40px;
        overflow: hidden;

        .category-list-inner {
          &.mr {
            margin-right: 100px;
          }
        }
      }

      .category-list-inner {
        &.mr {
          margin-right: 100px;
        }
      }

      .category-list-inner {

        .more {
          cursor: pointer;

          .icon-a-arrowright {
            display: inline-block;
            transform: rotate(90deg);
            transition: all 0.5s ease;

            &.sq {
              transform: rotate(270deg);

            }
          }
        }

      }


      .category {
        @include ElementHover(#6969FF, '');
        //transition: all 5s ease-in-out;
      }

      span, a {
        display: inline-block;
        font-size: 14px;
        color: #424866;
        line-height: 26px;
        height: 26px;
        padding: 0 8px;
        margin-right: 8px;
        margin-bottom: 16px;
        cursor: pointer;

        @include Screen(1) {
          padding: 0 4px;
        }

        &.on {
          border-radius: 6px;
          background: #6969FF;
          color: #FFFFFF;
          @include ElementHover(#FFFFFF, '');
        }


        @include Screen(1) {
          //background: pink;
          padding: 0 4px;
        }
      }
    }

    &.category-box {
      .category-list {
        flex-shrink: 0;

        &.NO {
          flex-shrink: 1;
          //padding-right: 90px;
          position: relative;

          .more {
            @include Position(1, 2, 0, 0);
            display: inline-block;
            font-size: 14px;
            color: #424866;
            line-height: 26px;
            height: 26px;
            padding: 0 8px;
          }
        }
      }
    }

  }

  .other-category-list {
    //width: 1161px;
    padding: 8px 60px 0 26px;
    //height: 78px;
    box-sizing: border-box;
    background: linear-gradient(90deg, #FFFFFF 0%, #F5F6FA 20%, #F5F6FA 78%, #FFFFFF 100%);
    border-radius: 8px;
    position: relative;
    margin-left: 24px;
    top: -8px;

    &.CLOSE {
      height: 45px;
      overflow: hidden;
    }

    .more {
      top: 8px !important;

      .icon-a-arrowright {
        display: inline-block;
        transform: rotate(90deg);
        transition: all 0.5s ease;

        &.sq {
          transform: rotate(270deg);

        }
      }
    }

    span, a {
      display: inline-block;
      height: 26px;
      font-size: 14px;
      color: #424866;
      line-height: 26px;
      margin-right: 24px;
      margin-bottom: 11px;
      cursor: pointer;
    }

    &:after {
      content: '';
      display: inline-block;
      width: 2px;
      height: 16px;
      background: rgba(66, 72, 102, 0.2);
      border-radius: 1px;
      @include Position(1, 5, 0, 13px);
    }

    @include Screen(1) {
      padding: 8px 60px 0 26px;
      span {
        margin-right: 22px;
      }
    }
  }
}

.menu-box-wrap {
  background-color: #fff;
  border-bottom: 1px solid #ECEFF6;

  .menu-box {
    flex: 1;
    //@include LayoutFlex(3);
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .layout-left {
      display: flex;
      align-items: center;

      .icon_line {
        width: 2px;
        height: 16px;
        background: #D9DAE1;
        border-radius: 1px;
        margin: 0 20px;
      }
    }


    .menu-list-box {
      display: flex;
      align-items: center;

      .category-name {
        margin-right: 12px;
        font-size: 14px;
        color: rgba(0, 16, 19, 0.45);
        line-height: 26px;
        flex-shrink: 0;
      }
    }

    .menu-list {
      @include LayoutFlex(1);
      //padding-left: 32px;

      &.leave {
        //border-left: 1px solid #ECEFF6;
      }

      .menu-item {
        font-size: 14px;
        color: #424866;
        line-height: 50px;
        margin-right: 20px;
        position: relative;
        @include ElementHover(#6969FF, '');

        .icon_recent-new {
          display: inline-block;
          @include Position(1, 2, -34px, 0px);
          //width: 45px;
          line-height: 16px;
          padding: 0 4px;
          background: linear-gradient(224deg, #FF906F 0%, #FF5E9F 100%);
          border-radius: 10px 2px 10px 2px;
          font-size: 12px;
          font-weight: bold;
          color: #FFFFFF;
        }


        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          color: #424866;
        }

        @include ElementHover('', '') {
          a {
            color: $color-primary;
          }
        }
      ;

        &.on {
          color: $color-primary;
          position: relative;

          a {
            color: $color-primary;
          }

          &:after {
            content: "";
            width: 100%;
            height: 2px;
            background-color: $color-primary;;
            border-radius: 2px;
            @include Position(1, 4, 0, 0);
            z-index: 5;

          }
        }
      }

      .bar {

      }
    }

    .pull-down-menus {
      height: 100%;
      @include LayoutFlex(1);


      .menu-item {
        height: 100%;
        transition: all 0.5s ease-in;
        position: relative;
        margin-left: 30px;

        &:hover {
          .icon-a-arrowupbold {
            transition: all 0.5s ease-in;
            display: inline-block;
            transform: rotateZ(180deg) !important;
          }
        }

        .menu-item-text {
          text-align: center;
          line-height: 58px;
          transition: all 0.5s ease-in;
          position: relative;
          //z-index: 10;
          background-color: #fff;

          span {
            display: inline-block;
            min-width: 60px;
            text-align: center;
          }

          .icon-a-arrowupbold {
            transition: all 0.5s ease-in;
            display: inline-block;
            transform: rotateZ(0deg);
            margin-left: 0px;
            font-size: 14px;
          }


        }

        .menu-item-content {
          @include Position(1, 5, 50%, 60px);
          transform: translateX(-50%);
          z-index: 5;
          //width: 122px;
          //height: 192px;
          padding: 6px;
          background: #FFFFFF;
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 26, 0.08);
          border-radius: 10px;
          @include LayoutFlex(2);
          transition: all 0.5s ease-in;

          &.leave {
            opacity: 0;
            z-index: -1;
          }

          &.on {
            opacity: 1;
            z-index: 5;
          }

          .menu-item-child {
            width: 110px;
            height: 36px;
            background: #FFFFFF;
            border-radius: 2px;
            @include LayoutFlex(1);
            font-size: 14px;

            a {
              display: inline-block;
              width: 100%;
              height: 100%;
              line-height: 36px;
              text-align: center;
            }

            &.on {
              background-color: $color-primary;
              color: #FFFFFF;

              a {
                color: #FFFFFF;
              }
            }
          }
        }
      }
    }

    .scene-list-box {
      //width: 72px;

      background: #F5F6FA;
      border-radius: 8px;
      position: relative;

      &:after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 10px;
        @include Position(1, 3, 0, -8px);

      }

      .category-name {
        width: 100%;
        height: 32px;
        line-height: 32px;
        padding: 0 29px 0 15px;
        box-sizing: border-box;
        position: relative;
        color: rgba(0, 16, 19, 0.8);

        i.icon_down {
          width: 0px;
          height: 0px;
          border: 5px solid transparent;
          border-top-color: rgba(0, 16, 19, 0.8);;
          @include Position(1, 2, 14px, 50%);
          transform: translateY(-25%);
        }

        .icon-cz-close-circle-fill {
          color: #A4A5B3;
          font-size: 12px;
          @include Position(1, 2, 10px, 50%);
          transform: translateY(-50%);
        }

        @include ElementHover(rgba(0, 16, 19, 1), '') {
          .icon_down {
            border-top-color: rgba(0, 16, 19, 1);;
          }
          .icon-cz-close-circle-fill {
            color: #757688;
          }
        }
      }

      .scene-list {
        width: 284px;
        height: 164px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 26, 0.08);
        border-radius: 10px;
        @include Position(1, 2, 0, 36px);
        z-index: 5;
        padding: 16px;
        box-sizing: border-box;
        animation: fadeinT 0.5s 1;

        .scene {
          display: inline-block;
          width: 76px;
          height: 36px;
          background: #F5F6FA;
          border-radius: 8px;
          margin: 0 12px 12px 0;
          font-size: 14px;
          color: #001013;
          line-height: 36px;
          text-align: center;

          &:nth-child(3n) {
            margin: 0;
          }

          @include ElementHover(#FFFFFF, $color-primary);

          &.ON {
            color: #FFFFFF;
            background: $color-primary;
          }

        }

      }
    }
  }
}

.type-box {
  display: flex;
  align-items: center;

  .type-list {
    display: flex;
    align-items: center;

    .category {
      margin-right: 20px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-right: 0;
      }

      @include ElementHover($color-primary, '') {
        .title {
          color: $color-primary;

          .dropbox {
            display: block;
          }
        }
      }
    ;
    }


    .iconfont {
      margin-right: 4px;

      &.icon-checkbox2 {
        color: rgba(25, 39, 42, 0.25);
      }

      &.icon-checkbox {
        color: $color-primary;
      }
    }


    .title {
      color: #424866;
      position: relative;

      .dropbox {
        @include Position(1, 5, 50%, 28px);
        transform: translateX(-50%);
        z-index: 9;
        background: #424866;
        border-radius: 8px;
        display: none;


        &:after {
          content: '';
          display: inline-block;
          width: 10px;
          height: 10px;
          background: #424866;
          @include Position(1, 5, 50%, -5px);
          transform: translateX(-50%) rotate(135deg);
        }

        .dropbox-item {
          //width: 200px;
          height: 28px;
          line-height: 28px;
          padding: 0px 8px;
          font-size: 12px;
          color: #FFFFFF;
          white-space: nowrap;

          &:last-child {
            margin-bottom: 0;
          }

        }
      }
    }
  }
}

</style>
